// X202 (R82 L11): whether the score grid opens another game / set / leg column. A 19-set "first to 10 sets" system left set 11
// open after a 10-0 win: the old test asked only whether ANY outcome had more home or more away wins (9-10 has more away wins
// than 10-0), so a decided match always kept one more column. Now a column opens only while some outcome can still be reached
// from the score so far (both sides' wins at least the current ones, one more), and never once the score so far is itself a
// final score with one side at its most wins (10-0 of first to 10, 3-1 of best of 5). A listed in-between outcome (a
// retirement 2-1 of best of 5) does not close the grid, and a play-all draw (2-2 of four) closes it as nothing is left.
const n = (v) => (v == null || v === '' ? null : Number(v));

export const winsSoFar = (games) => {
  let home = 0;
  let away = 0;
  for (const g of games || []) {
    const h = n(g?.homeTeamScore);
    const a = n(g?.awayTeamScore);
    if (h == null || a == null || h === a) continue;
    if (h > a) home++;
    else away++;
  }
  return {home, away};
};

export const moreGamesPossible = (outcomes, home, away) => {
  const scored = (outcomes || []).filter((o) => Number.isFinite(o?.homeGames) && Number.isFinite(o?.awayGames));
  if (scored.length === 0) return true;
  const maxHome = Math.max(...scored.map((o) => o.homeGames));
  const maxAway = Math.max(...scored.map((o) => o.awayGames));
  const isFinal = scored.some((o) => o.homeGames === home && o.awayGames === away);
  if (isFinal && (home === maxHome || away === maxAway)) return false;
  return scored.some((o) => o.homeGames >= home && o.awayGames >= away && (o.homeGames > home || o.awayGames > away));
};

/** Column `index` (0-based) can be typed into: the first always; a later one once the one before has a winner and the match is not decided. */
export const gameColumnPossible = (games, outcomes, index) => {
  if (index === 0) return true;
  const previous = games?.[index - 1];
  const h = n(previous?.homeTeamScore);
  const a = n(previous?.awayTeamScore);
  if (h == null || a == null || h === a) return false;
  const played = winsSoFar(games);
  // Filling in a column before the last one played stays open (editing a saved result).
  if (index < played.home + played.away) return true;
  return moreGamesPossible(outcomes, played.home, played.away);
};
